export const titleColor = 'rgb(153, 255, 153)';
export const backgroundMainColor = 'rgb(12, 35, 64)';
export const backgroundSubColor = 'rgb(18, 46, 78)';
export const gridCellBackgroundColor = 'rgb(34, 55, 82)';
export const gridCellFontColor = 'rgb(230, 204, 179)';
export const hoverColor = 'rgb(34, 55, 82)';